var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"top"},[_c('img',{attrs:{"src":'data:image/png;base64,' + _vm.base,"alt":""}})]),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.news)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }